import { IStormDoorEditingModel } from "../entities-generated/models/storm-door/storm-door-editing-model";
import { IStormDoorListing } from "../entities-generated/models/storm-door/storm-door-listing";
import { IUpdateStormDoorRequest } from "../entities-generated/models/storm-door/update-storm-door-request";
import { ApiClient } from "./admin-api-client";

class StormDoorApiClientClass {
  public getStormDoorForEditing(doorId: string) {
        return ApiClient.get<IStormDoorEditingModel>(`storm-doors/edit/${doorId}`);
    }

    public getStormDoorList() {
        return ApiClient.get<IStormDoorListing[]>(`storm-doors/list`);
    }

    public updateStormDoor(request: IUpdateStormDoorRequest) {
        return ApiClient.put<void>('storm-doors', request);
    }
}

export const StormDoorApiClient = new StormDoorApiClientClass();